import React, { FC, useContext, useRef } from "react";
import Button from "@natera/material/lib/button";
import { Dialog } from "@natera/material/lib/dialog";
import { defineMessages, useIntl } from "react-intl";
import { DialogsContext, PippaContext } from "@app/pippa/provider";
import { usePippaAnalytics } from "@app/pippa/hooks/usePippaAnalytics";
import "./closeWidgetDialog.scss";

const messages = defineMessages({
  chatMessageDialogExternalLink: {
    id: "chatMessageDialogExternalLink",
    defaultMessage: "Open the external resource link",
  },
  closeWidgetDialogTitle: {
    id: "closeWidgetDialogTitle",
    defaultMessage: "Close the Assistant now?",
  },
  closeWidgetDialogText: {
    id: "closeWidgetDialogText",
    defaultMessage:
      "This session includes important information to help you understand your results and explore next steps. You can close the Assistant now and return to this conversation at any time within the next 24 hours.",
  },
  closeChatButtonText: {
    id: "closeChatButtonText",
    defaultMessage: "Close the Assistant",
  },
  keepChattingButtonText: {
    id: "keepChattingButtonText",
    defaultMessage: "Continue conversation",
  },
});

const CloseWidgetDialog: FC = () => {
  const output = useRef<HTMLDivElement>(
    null
  ) as React.RefObject<HTMLDivElement>;
  const intl = useIntl();
  const { setIsWidgetOpen } = useContext(PippaContext);
  const { closeWidgetDialog } = useContext(DialogsContext);
  const { trackChatbotClosed } = usePippaAnalytics();

  const handleCloseWidgetDialogClose = () => {
    trackChatbotClosed();
    setIsWidgetOpen(false);
    closeWidgetDialog.close();
  };

  const handleCloseWidgetDialogContinue = () => {
    closeWidgetDialog.close();
  };

  const actions = (
    <>
      <Button
        onClick={handleCloseWidgetDialogClose}
        outlined
        className="close-button"
      >
        {intl.formatMessage(messages.closeChatButtonText)}
      </Button>
      <Button
        onClick={handleCloseWidgetDialogContinue}
        raised
        className="continue-button"
      >
        {intl.formatMessage(messages.keepChattingButtonText)}
      </Button>
    </>
  );

  return (
    <Dialog
      className="close-widget-dialog pippa-close-widget-dialog"
      onClose={() => undefined}
      actions={actions}
      title={intl.formatMessage(messages.closeWidgetDialogTitle)}
      focusTrapOptions={{ skipInitialFocus: true }}
    >
      <div ref={output} className="text-message__wrapper">
        <div className="dialog-container pippa-dialog-container">
          {intl.formatMessage(messages.closeWidgetDialogText)}
        </div>
      </div>
    </Dialog>
  );
};

export default CloseWidgetDialog;
